import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { templateGroupDetail, addtTemplateGroup, editTemplateGroup } from './request';
import { getDynamicResources } from './../frontPageManage/request';
import { PAGETYPE } from '@/views/template/controlManage/utils';
import { recursionCopy } from '@/views/customer/roleManage/utils';
import preview from './../frontPageManage/previewFrom';
export default {
  components: {
    preview
  },
  data() {
    return {
      current: -1,
      dataFrom: {
        name: '',
        // isPay: '',
        controlsGroupId: '',
        remark: ''
      },
      dialogVisible: false,
      PAGETYPE,
      pageTypeList: [],
      templateList: [],
      tagList: [],
      template: undefined,
      pageType: undefined,
      steps: [{
        title: '选择模版页面'
      }, {
        title: '配置页面流程'
      }],
      jumpList: [],
      //跳转列表
      copyJumpList: [],
      templateConfig: [],
      //模版配置
      templateGroupId: ''
    };
  },
  computed: {
    dataRule() {
      return {
        name: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('模板组名称')
        }],
        // isPay: [{required: true, message: '请选择是否需要支付', trigger: 'change'}],
        controlsGroupId: [{
          required: true,
          message: this.$t('请选择') + this.$t('模版'),
          trigger: 'change'
        }]
      };
    }
  },
  methods: {
    async init(val) {
      this.step = 1;
      this.pageTypeList = recursionCopy(this.PAGETYPE);
      // 去除产品列表页-产品列表不需要再模版组配置
      this.pageTypeList.forEach((item, index) => {
        if (item.key == 'PRODUCT_LIST_PAGE') {
          this.pageTypeList.splice(index, 1);
        }
      });
      console.log(val, this.pageTypeList);
      if (val) {
        this.templateGroupId = val.id;
        const res = await templateGroupDetail({
          templateGroupId: val.id
        });
        this.dataFrom = {
          templateGroupId: val.id,
          name: res.name,
          // isPay: res.isPay,
          remark: res.remark,
          controlsGroupId: res.controlsGroupId
        };
        //已选择的模版
        this.tagList = res.dynamicControls;
        // 已选择的模版页面类型不能再次选择
        res.dynamicControls.map(res => {
          const num = this.pageTypeList.findIndex(val => val.key == res.pageType);
          if (num != -1) {
            this.pageTypeList.splice(num, 1);
          }
        });
      }
      this.current = 0;
      this.dialogVisible = true;
    },
    // 获取每个页面类型下的所有模版
    async getDynamicResourcesFun() {
      this.templateList = await getDynamicResources({
        pageType: this.pageType
      });
    },
    // 下一步
    nextFun() {
      this.$refs.dataFrom.validate(valid => {
        if (valid) {
          this.jumpList = [];
          this.templateConfig = [];
          this.tagList.map(item => {
            this.jumpList.push({
              name: item.type,
              pageName: item.name,
              value: item.pageType,
              disabled: false
            });
            this.templateConfig.push({
              controlsGroupId: item.id,
              controlsGroupPageType: item.pageType,
              controlsGroupPageTypeName: item.type,
              controlsGroupPageName: item.name,
              //对应前端动态页面的模版名称controlsGroupPageName
              isHomePage: false,
              controlsGroupConfig: JSON.parse(item.controlsGroupConfig)
            });
          });
          // if (this.dataFrom.isPay == 'YES') {
          this.jumpList.push({
            name: '去支付',
            value: 'TO_PAY',
            disabled: false
          }, {
            name: '分享链接',
            value: 'TO_SHARE',
            disabled: false
          }, {
            name: '申请退保',
            value: 'TO_CANCEL_INSURANCE',
            disabled: false
          }, {
            name: '查看电子保单',
            value: 'TO_CHECK_INSURANCE',
            disabled: false
          }, {
            name: '申请发票',
            value: 'TO_INVOICE',
            disabled: false
          }, {
            name: '查看发票',
            value: 'TO_CHECK_INVOICE',
            disabled: false
          }, {
            name: '作废发票',
            value: 'INVOICE_OFFSET',
            disabled: false
          });
          // } else {
          //   this.jumpList.push({name:'提交信息',value:'SUBMIT_INFO',disabled:false});
          // }
          if (this.templateGroupId) {
            //缺少首页逻辑
          }
          this.current = 1;
          this.copyJumpList = recursionCopy(this.jumpList);
          console.log('已选择的模版列表', this.jumpList, this.templateConfig);
        }
      });
    },
    templateChangeFun() {
      console.log(this.template);
      const arr = this.templateList.filter(item => item.id == this.template);
      this.tagList.push(arr[0]);
      const typeList = this.pageTypeList.filter(item => item.key !== this.pageType);
      this.pageType = undefined;
      this.template = undefined;
      this.pageTypeList = typeList;
      this.getControlsGroupFun();
      this.$refs.dataFrom.validateField('controlsGroupId');
    },
    tagClose(removedTag) {
      const tags = this.tagList.filter(tag => tag.id !== removedTag.id);
      this.tagList = tags;
      this.pageTypeList.push({
        name: removedTag.type,
        key: removedTag.pageType
      });
      this.getControlsGroupFun();
    },
    getControlsGroupFun() {
      let arr = [];
      this.tagList.map(item => {
        arr.push(item.id);
      });
      this.dataFrom.controlsGroupId = arr.length != 0 ? arr.join(',') : '';
    },
    // 查询记录页卡片的按钮事件
    cardControlsJumpFun() {},
    controlsJumpFun() {
      let btnArr = [];
      this.templateConfig.map(item => {
        let data = item.controlsGroupConfig.controlsConfig[item.controlsGroupConfig.controlsConfig.length - 1].controlsObject.buttonInfo;
        if (data) {
          data.map((btn, btnIndex) => {
            if (btn.buttonPopUp) {
              let _isJump = btn.buttonPopUpConfig.buttonInfo.findIndex(b1 => b1.buttonEvent == 'jump');
              if (_isJump > -1) {
                btnArr = btnArr.concat([data[btnIndex].buttonPopUpConfig.buttonInfo[_isJump]]);
              }
            } else {
              btnArr = btnArr.concat(btn);
            }
          });
        }

        // let popupIndex = data.findIndex(i => i.buttonPopUp);
        // if (popupIndex > -1) {
        //   let btnIndex = data[popupIndex].buttonPopUpConfig.buttonInfo.findIndex(i => i.buttonEvent == 'jump');
        //   if (btnIndex > -1) {
        //     btnArr = btnArr.concat([data[popupIndex].buttonPopUpConfig.buttonInfo[btnIndex]]);
        //   }
        // } else {
        //   btnArr = btnArr.concat(data);
        // }
      });
      // 设置跳转按钮是否禁用
      this.jumpList.map(item => {
        const num = btnArr.findIndex(val => val.controlsJump && val.controlsJump == item.value && item.value != 'DETAILS' && item.value != 'LANDING_PAGE' && item.value != 'QUERY_INFO_PAGE' && item.value != 'INVOICE_PAGE');
        item.disabled = num != -1 ? true : false;
      });
    },
    setHomeFun(valIndex) {
      this.templateConfig.map((item, index) => {
        item.isHomePage = valIndex == index ? true : false;
      });
    },
    repeatyArr(arr) {
      console.log(arr, '------arr--------');
      var find = false;
      for (var i = 0; i < arr.length; i++) {
        for (var j = 0; j < ((_arr$i$controlsGroupC = arr[i].controlsGroupConfig.controlsConfig[arr[i].controlsGroupConfig.controlsConfig.length - 1].controlsObject.buttonInfo) === null || _arr$i$controlsGroupC === void 0 ? void 0 : _arr$i$controlsGroupC.length); j++) {
          var _arr$i$controlsGroupC;
          let res = arr[i].controlsGroupConfig.controlsConfig[arr[i].controlsGroupConfig.controlsConfig.length - 1].controlsObject.buttonInfo[j];
          if (res.buttonPopUp) {
            var _res$buttonPopUpConfi;
            if (!((_res$buttonPopUpConfi = res.buttonPopUpConfig.buttonInfo.find(i => i.buttonEvent == 'jump')) !== null && _res$buttonPopUpConfi !== void 0 && _res$buttonPopUpConfi.controlsJump)) {
              find = arr[i];
              break;
            } else {
              continue;
            }
          }
          if (!res.controlsJump) {
            find = arr[i];
            break;
          }
        }
        if (find) break;
      }
      return find;
    },
    async saveFun() {
      const ARR = this.templateConfig.filter(item => item.isHomePage);
      if (ARR.length == 0) {
        return this.$message.error(this.$t('未设置首页，请设置后保存'));
      }
      const FIND = this.repeatyArr(this.templateConfig);
      console.log(FIND);
      if (FIND) {
        return this.$message.error(this.$t('请完成') + FIND.controlsGroupPageTypeName + this.$t('页面的按钮跳转配置'));
      }
      // 卡片按钮跳转设置必选
      const CARD = this.templateConfig.filter(item => item.controlsGroupPageType == 'QUERY_INFO_PAGE');
      let cardFind = true;
      console.log(CARD, 'CARD');
      if (CARD.length > 0) {
        let policyCardFind = true;
        let orderCardFind = true;
        console.log(CARD, 'CARD map');
        CARD.map(item => {
          var _item$controlsGroupCo;
          (_item$controlsGroupCo = item.controlsGroupConfig) === null || _item$controlsGroupCo === void 0 || (_item$controlsGroupCo = _item$controlsGroupCo.controlsConfig) === null || _item$controlsGroupCo === void 0 || _item$controlsGroupCo.map(control => {
            var _control$controlsObje, _control$controlsObje2;
            console.log(control, 'control');
            if (control.controlsMark != 'queryInfo') return;
            //保单卡片按钮展示
            if ((_control$controlsObje = control.controlsObject) !== null && _control$controlsObje !== void 0 && (_control$controlsObje = _control$controlsObje.policySearch) !== null && _control$controlsObje !== void 0 && (_control$controlsObje = _control$controlsObje.buttonInfo) !== null && _control$controlsObje !== void 0 && _control$controlsObje.buttonDisplay) {
              control.controlsObject.policySearch.buttonInfo.buttons.map(btn => {
                if (!btn.controlsJump) {
                  policyCardFind = false;
                } else {
                  policyCardFind = true;
                }
              });
            }
            //订单卡片按钮展示
            if ((_control$controlsObje2 = control.controlsObject) !== null && _control$controlsObje2 !== void 0 && (_control$controlsObje2 = _control$controlsObje2.orderSearch) !== null && _control$controlsObje2 !== void 0 && (_control$controlsObje2 = _control$controlsObje2.buttonInfo) !== null && _control$controlsObje2 !== void 0 && _control$controlsObje2.buttonDisplay) {
              control.controlsObject.orderSearch.buttonInfo.buttons.map(btn => {
                if (!btn.controlsJump) {
                  orderCardFind = false;
                } else {
                  orderCardFind = true;
                }
              });
            }
          });
        });
        if (!policyCardFind) {
          return this.$message.error(this.$t('请完成') + this.$t('查询记录页') + this.$t('保单卡片按钮') + this.$t('的') + this.$t('跳转配置'));
        }
        if (!orderCardFind) {
          return this.$message.error(this.$t('请完成') + this.$t('查询记录页') + this.$t('订单卡片按钮') + this.$t('的') + this.$t('跳转配置'));
        }
        if (policyCardFind && orderCardFind) {
          cardFind = true;
        }
      }
      if (!cardFind) {
        return;
      }
      this.dataFrom.templateCongfig = JSON.stringify(recursionCopy(this.templateConfig));
      const FUN = this.templateGroupId ? editTemplateGroup : addtTemplateGroup;
      console.log(this.dataFrom, '保存的数据');
      await FUN(this.dataFrom);
      this.$message.success(this.$t('操作成功'));
      this.$emit('save');
      this.$emit('cancel');
    }
  }
};